export const AVAILABILITY_TEXT = {
    PRE_ORDER: "Pre-Order",
    UNITS_SUFFIX: "Units",
    MOQ_PREFIX: "MOQ",
    MOQ_SUFFIX: "units",
    EMPTY_DATE: "-",
    MOQ_ALERT: "Minimal order quantity is",
    MIN_ORDER_PREFIX: "Min:",
    MAX_ORDER_PREFIX: "Max:",
    OUT_OF_STOCK: "Out of Stock",
    QUANTITY_SEPARATOR: "|",
    ONE_WEEK: "Est. 1 week",
    TWO_WEEKS: "1 - 2 weeks",
    THREE_WEEKS: "2 - 3 weeks",
    FOUR_WEEKS: "3 - 4 weeks",
    ONE_MONTH: "1+ month"
} as const;
